import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { Box, Typography } from '@material-ui/core'

import utilityConfig from 'app/configs/utilityConfigs'
import PanelsIllustrationMSG from 'app/componentV4/Panels/IllustrationMSG'

import LinkToSignup from 'app/componentV4/Link/LinkToSignup'

const SuspendedAccount = (props) => {
  const { reason = 'Suspension' } = props
  const { formatMessage } = useIntl()

  return (
    <PanelsIllustrationMSG>
      <div className="flex justify-center items-center h-full">
        <div className="w-full space-y-10">
          {/* Header */}
          <Typography className="text-24 font-500 text-primary text-center">
            {formatMessage({ id: 'MessageSpring Admin Dashboard' })}
          </Typography>

          <Typography className="text-16 text-red-500 text-center mx-5">
            {formatMessage({ id: 'suspended.title' })}
          </Typography>

          <Typography className="text-14 text-primary-300 text-center mx-5">
            {formatMessage({ id: 'suspended.subTitle' })}
          </Typography>

          <Box className="rounded-8 py-5 px-10 bg-red-50">
            <Typography className="text-16 text-red-500 text-primary text-center">
              {reason}
            </Typography>
          </Box>

          <Typography className="text-14 text-primary-300 text-center">
            {formatMessage(
              {
                id: 'suspended.footer',
              },
              {
                linkEmail: (
                  <a
                    href={`mailto:${utilityConfig.supportUrl}`}
                    className="text-primary font-bold"
                  >
                    {utilityConfig.supportUrl}
                  </a>
                ),
              },
            )}
          </Typography>

          <div className="flex items-center">
            <div className="flex-1 border-t border-primary-350"></div>
            <Typography className="text-16 text-primary-300 text-center mx-5">
              {formatMessage({ id: 'or' })}
            </Typography>
            <div className="flex-1 border-t border-primary-350"></div>
          </div>
          <LinkToSignup />
        </div>
      </div>
    </PanelsIllustrationMSG>
  )
}

SuspendedAccount.propTypes = {
  reason: PropTypes.string,
}

export default SuspendedAccount
